import { masterTherapyActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  masterTherapyList: null,
  postMasterTherapyData: null,
  getMasterTherapyById: null,
  deleteMasterTherapy: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {

    case masterTherapyActionTypes.get_master_therapy.REQUEST:
      return {
        ...state,
        loading: true,
        masterTherapyList: null,
      };
    case masterTherapyActionTypes.get_master_therapy.SUCCESS:
      return {
        ...state,
        masterTherapyList: payload,
        loading: false,
      };
    case masterTherapyActionTypes.post_master_therapy.REQUEST:
      return {
        ...state,
        loading: true,
        postMasterTherapyData: null,
      };
    case masterTherapyActionTypes.post_master_therapy.SUCCESS:
      return {
        ...state,
        postMasterTherapyData: payload,
        loading: false,
      };
    case masterTherapyActionTypes.get_master_therapy_by_id.REQUEST:
      return {
        ...state,
        loading: true,
        getMasterTherapyById: null,
      };
    case masterTherapyActionTypes.get_master_therapy_by_id.SUCCESS:
      return {
        ...state,
        loading: false,
        getMasterTherapyById: payload,
      };
    case masterTherapyActionTypes.delete_master_therapy.REQUEST:
      return {
        ...state,
        loading: true,
        deleteMasterTherapy: null,
      };
    case masterTherapyActionTypes.delete_master_therapy.SUCCESS:
      return {
        ...state,
        deleteMasterTherapy: payload,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterTherapy/reducers/MasterTherapyReducer.js